import React, { memo } from 'react';

import { AdfoxContextProviderProps } from '../../../../../../utils/AdfoxContext';
import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_parallax',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 200 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'czsow', p2: 'y' };

type SuburbanListingBannerProps = {
  position: number;
};

export const SuburbanListingBanner = memo<SuburbanListingBannerProps>(function SuburbanListingBanner(props) {
  const { position } = props;

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="AdFox баннер для загородки"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
});
